export default __webpack_public_path__ + "static/9-528684c9cabf2e34a5d5853e95c14742.jpg";